import { useState } from "react";
import { Article } from "../../services/coworkerApiCalls/Article/ArticlesTypes";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ArticleEdit } from "../../components/article/article";
// import { getSpaces } from "../../services/coworkerApiCalls/Space/Space";
// import { getCategories } from "../../services/coworkerApiCalls/Category/Category";

const AddArticle: React.FC = () => {
    const [article] = useState<Article>({
        title: '',
        content: '',
        image: '',
        startDate: Date.now(),
        endDate: Date.now(),
        spaceId: 0,
        categoryId: 0,
        creationDate: 0,
        id: 0,
        modificationDate: 0
    });

    return (
        <div>
            <ArticleEdit {...article}></ArticleEdit>
        </div>
    );
};

export { AddArticle };